import { create } from "zustand";

export type Theme = "dark" | "light";

function readTheme(): Theme {
  try {
    return localStorage.getItem("kompil.theme") === "light" ? "light" : "dark";
  } catch {
    return "dark";
  }
}

/** Tema escuro (preto) é o padrão; claro (branco) é opcional. */
export const useTheme = create<{ theme: Theme; setTheme: (t: Theme) => void; toggle: () => void }>(
  (set, get) => ({
    theme: readTheme(),
    setTheme: (theme) => {
      document.documentElement.classList.toggle("dark", theme === "dark");
      document
        .querySelector('meta[name="theme-color"]')
        ?.setAttribute("content", theme === "dark" ? "#000000" : "#ffffff");
      try {
        localStorage.setItem("kompil.theme", theme);
      } catch {
        // armazenamento indisponível: o tema vale só para esta aba
      }
      set({ theme });
    },
    toggle: () => get().setTheme(get().theme === "dark" ? "light" : "dark"),
  }),
);
